import React, { useEffect, useState } from "react";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import config from "../../Config";
import PrintHeader from "../General/PrintHeader";
import Page from "../General/Page";

function PrintMarksCriteria() {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [criteria, setCriteria] = useState(null);

  useEffect(() => {
    document.title = "Marks Criteria";
    const urlParams = new URLSearchParams(window.location.search);
    const data = {
      AccessKey,
      UserID,
      MemberType: MemberType || "Admin",
      ID: parseInt(urlParams.get("ID"), 10) || 0,
    };

    axios({
      method: "post",
      url: config.base_url + "ResultCard/GetMarksCriteria",
      headers: { "Content-Type": "application/json" },
      data,
    })
      .then((response) => {
        if (response.data.status_code === 1) {
          setCriteria(
            response.data.Criteria || {
              ResultCard: response.data.ResultCard,
              Components: response.data.Components,
              Grade_Bands: response.data.Grade_Bands,
            }
          );
        } else {
          setError(response.data.status_message || "Unable to load marks criteria.");
        }
        setLoading(false);
      })
      .catch(() => {
        setError("Network error while loading marks criteria.");
        setLoading(false);
      });
  }, [AccessKey, UserID, MemberType]);

  if (loading) {
    return (
      <div className="text-center p-5">
        <Spinner animation="border" role="status" />
      </div>
    );
  }

  if (error) {
    return <div className="alert alert-danger m-4">{error}</div>;
  }

  const card = criteria?.ResultCard;
  const components = criteria?.Components || [];
  const bands = criteria?.Grade_Bands || [];

  return (
    <Page orientation="portrait" size="a4">
      <PrintHeader title="Marks Criteria & Grade Scale" />
      <div className="p-3">
        <h5 className="mb-1">{card?.Print_Title || card?.Title}</h5>
        <p className="text-muted mb-4">
          Code: {card?.ResultCard_Code} &middot; Type: {card?.Result_Type} &middot; Grade
          scale: {card?.Grade_Scale_Type || "Standard"}
        </p>

        <h6>Source exams &amp; weightage</h6>
        <table className="table table-bordered table-sm mb-4">
          <thead>
            <tr>
              <th>#</th>
              <th>Exam</th>
              <th>Weight %</th>
              <th>Mode</th>
              <th>In Total</th>
              <th>Display Label</th>
            </tr>
          </thead>
          <tbody>
            {components.map((comp, i) => (
              <tr key={comp.ID || comp.Source_Exam_ID}>
                <td>{comp.Sort_Order || i + 1}</td>
                <td>{comp.Exam_Print_Title || comp.Exam_Name}</td>
                <td>{comp.Weightage_Percent}%</td>
                <td>{comp.Weightage_Mode || "PercentOfExam"}</td>
                <td>{comp.Include_In_Total ? "Yes" : "No"}</td>
                <td>{comp.Display_Label || "-"}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <h6>Grade scale ({card?.Grade_Scale_Type || "Standard"})</h6>
        <table className="table table-bordered table-sm mb-4">
          <thead>
            <tr>
              <th>Grade</th>
              <th>Minimum %</th>
              <th>Description</th>
            </tr>
          </thead>
          <tbody>
            {bands.map((band) => (
              <tr key={band.Grade}>
                <td><strong>{band.Grade}</strong></td>
                <td>{band.Min_Percent}</td>
                <td>{band.Description}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <h6>Calculation notes</h6>
        <ul className="small mb-0">
          <li>
            <strong>PercentOfExam</strong> — each component contributes (exam % × weightage %).
          </li>
          <li>
            <strong>SimpleSum</strong> — raw obtained marks are summed across components.
          </li>
          <li>
            Composite master sheet and published results use the same calculation engine.
          </li>
          <li>Verify all component marks before publishing from the master sheet page.</li>
        </ul>
      </div>
    </Page>
  );
}

export default PrintMarksCriteria;
